import { resolve_onboarding_journey_filter } from '@/services/onboarding_journey_filter_service';

function get_queue_form_name(case_item = {}) {
  const name = case_item.name || '';
  return name;
}

function get_queue_form_company(item = {}) {
  const company = item.company || '';
  return company;
}

function get_queue_form_entity_type_id(case_item = {}) {
  const entity_type_id = case_item.entity_type_id || case_item.threshold_entity_type_id_used || '';
  return String(entity_type_id);
}

function get_queue_form_journey(item = {}, case_item = {}) {
  const journey = case_item.journey_key || case_item.entity_type_id || case_item.threshold_entity_type_id_used || item.journey_key || '';
  return journey;
}

function get_queue_form_journey_label(item = {}, case_item = {}) {
  const journey_label = case_item.journey || item.journey || '';
  return journey_label;
}

function build_route_journey_query(journey = '', journey_label = '') {
  const query = journey_label ? { journey, journey_label } : { journey };
  return query;
}

function get_current_route_journey(route = {}) {
  return String(resolve_onboarding_journey_filter(route).id || '').trim();
}

function get_current_route_journey_label(route = {}) {
  return String(resolve_onboarding_journey_filter(route).label || '').trim();
}

function get_current_route_journey_query(route = {}) {
  const journey = get_current_route_journey(route);
  const journey_label = get_current_route_journey_label(route);
  return journey ? build_route_journey_query(journey, journey_label) : {};
}

function get_queue_journey_values(item = {}, case_item = {}, current_route = {}) {
  const current_journey_query = get_current_route_journey_query(current_route);
  if (!current_journey_query.journey) {
    return { journey: '', journey_label: '' };
  }

  const values = {
    journey: current_journey_query.journey || get_queue_form_journey(item, case_item),
    journey_label: current_journey_query.journey_label || get_queue_form_journey_label(item, case_item)
  };
  return values;
}

function apply_queue_form_journey_query(route_query, item = {}, case_item = {}, current_route = {}) {
  const journey_values = get_queue_journey_values(item, case_item, current_route);
  if (journey_values.journey) route_query.journey = journey_values.journey;
  if (journey_values.journey_label) route_query.journey_label = journey_values.journey_label;
}

export function build_queue_form_route(item = {}, case_item = {}, current_route = {}) {
  const route_query = {
    name: get_queue_form_name(case_item),
    company: get_queue_form_company(item),
    entity_type_id: get_queue_form_entity_type_id(case_item),
    application_form_id: ''
  };
  apply_queue_form_journey_query(route_query, item, case_item, current_route);
  const route = {
    name: 'MyQueueForm',
    params: { applicationId: String(case_item.application_id) },
    query: route_query
  };
  return route;
}

function read_detail_entry(detail = {}, key = '', fallback = null) {
  const value = detail != null ? Reflect.get(detail, key) ?? fallback : fallback;
  return value;
}

function get_detail_array(value) {
  const resolved_array = Array.isArray(value) ? value : [];
  return resolved_array;
}

export function normalize_created_onboarding_detail(detail = {}) {
  const normalized_detail = {
    creation_response: read_detail_entry(detail, 'creation_response', {}),
    onboarding_form: read_detail_entry(detail, 'onboarding_form', {}),
    selected_project: read_detail_entry(detail, 'selected_project', {}),
    selected_entity_type: read_detail_entry(detail, 'selected_entity_type', {}),
    selected_roles: get_detail_array(read_detail_entry(detail, 'selected_roles', [])),
    selected_templates: get_detail_array(read_detail_entry(detail, 'selected_templates', []))
  };
  return normalized_detail;
}

function get_open_queue_case_item(item = {}) {
  const case_item = item?.case_item;
  return case_item;
}

function get_open_queue_action_key(case_item = {}, item = {}) {
  const action_key = `detail:${case_item.application_id || item.id || ''}`;
  return action_key;
}

function prepare_open_queue_item(vm, item, case_item, helpers) {
  vm.queue_action_key = get_open_queue_action_key(case_item, item);
  helpers.dispatch_system_loader('Loading onboarding detail...');
  helpers.dispatch_case_scope_selected(case_item);
  vm.active_detail_tab = 'summary';
  const initial_case = vm.apply_persisted_edits_to_case(case_item);
  helpers.apply_case_detail_state(vm, helpers.build_case_detail_empty_state(initial_case, vm));
  vm.$nextTick(() => vm.update_detail_tab_overflow());
  vm.is_loading_detail = true;
  return initial_case;
}

function try_hydrate_queue_item_detail(vm, case_item, initial_case, helpers) {
  const hydration = helpers.hydrate_selected_case(vm, case_item)
    .then(() => {
      vm.$nextTick(() => vm.update_detail_tab_overflow());
    })
    .catch(() => {
      vm.selected_case = initial_case;
    })
    .finally(() => {
      vm.is_loading_detail = false;
      vm.queue_action_key = '';
      helpers.clear_system_loader();
    });
  return hydration;
}

export async function open_queue_item_detail(vm, item = {}, helpers) {
  const case_item = get_open_queue_case_item(item);
  if (!case_item) return;
  const initial_case = prepare_open_queue_item(vm, item, case_item, helpers);
  await try_hydrate_queue_item_detail(vm, case_item, initial_case, helpers);
}
